import React from 'react';
import Button from './Button';
 // Uncomment these and icon below to use FontAwesome instead of CSS icon
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPause } from '@fortawesome/free-solid-svg-icons';

function PauseScreen({ unPause, endSession }) {
    return (
        <div
            style={{
                position: 'absolute',
                color: 'white',
                top: '0px',
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                borderColor: 'rgba(255, 255, 255, 0.5)',
                display: 'grid',
                gridTemplateRows: '2fr 2fr 2fr 2fr 1fr 1fr',
                zIndex: 9999999,
                overflow: 'hidden',
            }}
            className="appear"
        >
            <div />
            <div
                style={{
                    display: 'grid',
                    alignItems: 'end',
                    justifyItems: 'center',
                    fontSize: '1.2em',
                    fontWeight: 'bold',
                }}
            >
                <p>Paused</p>
            </div>
            <div
                style={{
                    display: 'grid',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '5em',
                }}
            >
                {/* This is the 'pause' icon, made using CSS */}
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '3fr 2fr 3fr',
                        width: '0.8em',
                        height: '1em',
                    }}
                    onClick={unPause}
                >
                    <div style={{ backgroundColor: 'white' }} />
                    <div style={{ backgroundColor: 'transparent' }} />
                    <div style={{ backgroundColor: 'white' }} />
                </div>
                {/* <FontAwesomeIcon icon={faPause} onClick={unPause} /> */}
            </div>
            <div
                style={{
                    display: 'grid',
                    alignContent: 'center',
                    justifyContent: 'center',
                    fontSize: '1.1em',
                    alignItems: 'start',
                    marginTop: '-30px',
                }}
            >
                <p onClick={unPause}>Tap to resume</p>
            </div>
            <div
                style={{
                    display: 'grid',
                    justifyContent: 'center',
                    alignContent: 'center',
                }}
            >
                <Button onClick={endSession} label="End session" />
            </div>
            <div />
        </div>
    );
}

export default PauseScreen;
